import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useStyles } from './useStyles';
import { useHistory } from 'react-router-dom';
import { SiteTaskListView } from '../../components/parts/task/TaskListView';
import { useHooks } from './useHooks';
import BasePageLayoutWrapper from '../../components/parts/common/BasePageLayoutWrapper';
import { TTopicPathState } from '../../components/topicPath/type/Type';
import { Button } from '@material-ui/core';

export const SiteTaskPage: React.FC = () => {
  const { constructId, siteProcessId, viewAlert, patternState, listMode } =
    useHooks();
  const classes = useStyles();
  const history = useHistory();

  return (
    <BasePageLayoutWrapper patternName='site_tasks' patternState={patternState}>
      <div className={classes.backLinkWrapper}>
        <Button
          style={{
            minWidth: 90,
            marginRight: 15,
            color: '#758283',
            backgroundColor: '#F5F5F5'
          }}
          variant='contained'
          color='secondary'
          onClick={() => {
            if (listMode) {
              console.log(listMode, 'listMode');
              history.push(`/processes`, {
                constructId: constructId,
                listMode: true
              });
            } else {
              history.push(`/processes`, {
                constructId: constructId
              });
            }
          }}
          startIcon={<ArrowBackIcon />}
        >
          戻る
        </Button>
      </div>
      <SiteTaskListView
        constructId={constructId}
        siteProcessId={siteProcessId}
        viewAlert={viewAlert}
      />
    </BasePageLayoutWrapper>
  );
};
